/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
import React, { useState, useCallback, useEffect } from 'react'
import EmptyPage from '../../../Components/EmptyPage'
import OfferProductCard from '../../../Components/OfferProductCard'
import { FilterPayloadConstruction } from '../../../redux/helper/FIlterPayloadConstructor'
import { distributorService } from '../../../service/distributor.service'
import IndividualCriteriaSummary from '../IndividualCriteriaSummary'
import OffersProductsSkeleton from '../OfferDetailSkeleton/OffersProductsSkeleton'
import InfiniteScroll from 'react-infinite-scroll-component';
import ResposiveFilterModal from '../../ProductsList/ResposiveFilterModal'

export default function ProductSection({
    setsearchValue,
    setcartCountObj,
    showNotMaching,
    setloading,
    wishlistProduct,
    setshowNotMaching,
    IsSameDeal,
    criteriaObject,
    specialCartList,
    cartCountObj,
    SpecialList,
    ViewOffer,
    handleCat,
    offerId,
    setresult,
    setshowProducts,
    prodItem,
    CriteriaObj,
    selectedCriteria,
    GetCartItems,
    cartCount,
    GetOfferData,
    setCriteriaObj,
    initialState,
    GetProductList,
    setcartProducts,
    cartProducts,
    categories,
    productsloader, result,
    setselectedCriteria,
    priceRange, setpriceRange,
    setproductsloader,
    Size, setSize, filterParam, specialRecurring,criteriaMainObject,subsequentOrder,
    offerData }) {
    const [ErrorID, setErrorID] = useState('');
    const [OrderValue, setOrderValue] = useState(offerData && offerData?.items[prodItem[selectedCriteria]?.id]?.orderValue || 0);
    const [updateAmount, setupdateAmount] = useState(false)
    const [Segments, setSegments] = useState([]);
    const [payload, setpayload] = useState(offerData.items[prodItem[selectedCriteria].id].payload);
    const [checkBox, setcheckBox] = useState([]);
    const [mainCategories, setmainCategories] = useState([]);
    const [currentPage, setcurrentPage] = useState(1);
    const [infiniteLoader, setinfiniteLoader] = useState(false)
    const [resposivePopup, setresposivePopup] = useState(false);
    const [Filters, setFilters] = useState({});
    const [sizeList, setSizeList] = useState([]);
    const [lengthList, setLengthList] = useState([]);

    const GetCartCount = (i, total) => {
        let finalCount = 0;
        Object.keys(CriteriaObj[prodItem[selectedCriteria].id].cartCount).length > 0 && Object.keys(CriteriaObj[prodItem[selectedCriteria].id].cartCount).map((item) => {
            const Selected = CriteriaObj[prodItem[selectedCriteria].id].cartCount
            if (Selected[item] > 0) {
                finalCount += total !== undefined ? Number(Selected[item]) : 1
            }
        })
        return finalCount

    }
    const handleApply = (clear, price) => {
        let payloadCopy = {}
        let spredpayload = { ...payload }
        if (clear) {
            spredpayload = { ...initialState }
        } else {
            payloadCopy.PRICE_RANGE = undefined;
            if (Size?.DIAMETER !== "") {
                spredpayload.filter.DIAMETER = Size.DIAMETER
            } else {
                spredpayload.filter.DIAMETER = undefined;
            }
            if (Size?.LENGTH !== "") {
                spredpayload.filter.LENGTH = Size.LENGTH
            } else {
                spredpayload.filter.LENGTH = undefined;

            }
            if (priceRange.minValue > -1 && priceRange.maxValue > 0) {
                spredpayload.filter.PRICE_RANGE = [priceRange.minValue, priceRange.maxValue];
            }
            else {
                spredpayload.filter.PRICE_RANGE = undefined;
            }
            // if(price?.min > -1 && price?.max > 0){
            //     payloadCopy.PRICE_RANGE=[String(price.min),String(price.max)];
            //     spredpayload.filter={
            //         PRICE_RANGE:[String(price.min),String(price.max)]
            //     }
            // }            
            if (result && Object.keys(result).length > 0) spredpayload.filter.category = FilterPayloadConstruction(result)
        }
        if (spredpayload?.filter?.category?.length === 0) {
            delete spredpayload.filter.category;

        }
        if (payloadCopy?.category?.length === 0) {
            delete payloadCopy.category
        }
        payloadCopy = spredpayload;
        setcurrentPage(1)
        setpayload(spredpayload);
        // setproductsloader(true)
        GetProductList('', '', payloadCopy)
        setresponsivePopup(false)
    }
    const handleCheckBox = (item, segments) => {
        let copy = [];
        if (segments) {
            copy = [...Segments]
        } else {
            copy = [...checkBox]
        }
        let keyval = item
        if (copy.includes(item)) {
            keyval = item.split('.')[item.split('.').length - 1];
            let parentKeyValue = item.split('.')[item.split('.').length - 2]
            let idx;
            const Duplicates = []
            copy.map((val, i) => {
                if (val?.split('.').includes(keyval)) {
                    Duplicates.push(copy.indexOf(val))
                }
            })
            if (Duplicates.length > 1) {
                idx = Duplicates[Duplicates.length - 1]
            } else {
                idx = copy.indexOf(item)
            }
            copy.splice(idx, 1)
            const removeArr = []
            copy.map((val) => {
                if (!val?.split('.').includes(keyval)) {
                    removeArr.push(val)
                }
            })
            let parentCount = 0;
            copy.map((val) => {
                if (val?.split('.').includes(parentKeyValue)) {
                    parentCount += 1;
                }
            })
            copy = removeArr;
        } else {
            if (item.split('.').length === 0) {
                copy.push(item)
            } else {
                let temp = ''
                item.split('.').map((val, i) => {
                    temp += i === 0 ? `${val}` : `.${val}`
                    if (!copy.includes(temp)) {
                        copy.push(temp)
                    }
                });
                keyval = item.split('.')[item.split('.').length - 1]
            }
            if (segments === undefined) {
                findSegmnet(Filters, keyval, copy);
            }
        }
        if (segments) {
            setSegments(copy)
            // handleCheckboxSegments(keyval?.split('.')[0],item,copy);
        } else {
            setcheckBox(copy)
        }

    }
    const handlePayload = useCallback(
        (key, value) => {
            if (key === 'PRICE_RANGE') {
                setpayload((state) => ({
                    ...state,
                    PRICE_RANGE: [value.minValue, value.maxValue],
                    page: 1
                }))
            } else {
                setpayload((state) => ({
                    ...state,
                    [key]: value,
                    page: 1
                }))
            }
            handleToggle(key);
            if (key !== 'search') {
                setInitialLoad(true);

            }
            setcurrentPage(1)
        }, [payload]);
    const arr = [];
    const findSegmnet = (obj, searchKey, arr) => {
        for (var property in obj) {
            if (obj.hasOwnProperty(property)) {
                if (Object.keys(obj[property]).length > 0 && property !== "" && property !== 'concatenated_segment') {
                    if (obj[property].concatenated_segment.split('.').includes(searchKey)) {
                        if (!arr.includes(obj[property].concatenated_segment)) {
                            arr.push(obj[property].concatenated_segment)
                        }
                    }
                    findSegmnet(obj[property], searchKey, arr);
                } else {
                    if (obj.concatenated_segment.split('.').includes(searchKey)) {
                        if (!arr.includes(obj[property].concatenated_segment)) {
                            arr.push(obj[property].concatenated_segment)
                        }
                    }
                }
            }
        }
        return arr
    }

    const handleFetchFilters = useCallback((() => {
        const data = transform(categories, '', 1);
        setresult(data)
        setLengthList(filterParam.LENGTH);
        setSizeList(filterParam.DIAMETER);
    }), []);

    const handleClear = () => {
        setSegments([]);
        setSize({
            LENGTH: '',
            DIAMETER: ''
        });
        setpriceRange((state) => ({
            ...state,
            maxValue: 0,
            minValue: 0
        }))
        handleFetchFilters()
        setcheckBox([]);
        handleApply('clear')
    }
    function transform(object, newid, id1) {
        if (Object.keys(object).length > 0) {
            return Object
                .entries(object).filter(([keyVal, value]) => value !== '' && keyVal !== '')
                .map(([name, value]) => {
                    if (value.hasOwnProperty('')) {
                        Object.keys(value).map((key) => key === '' && delete value[key])
                    }
                    if (value !== "") {
                        return Object.assign({ name }, value && typeof value === 'object' && !value.hasOwnProperty('')
                            ? {
                                newid: `${id1++}-${name}`
                                , id: `${newid === '' ? '' : `${newid}.`}${name}`,
                                items:
                                    transform(value, `${newid === '' ? '' : `${newid}.`}${name}`, Object.keys(object).length)
                            }
                            : { newid: `${id1++}-${name}`, id: `${newid === '' ? '' : `${newid}.`}${name}` }
                        )
                    }
                });
        }
    }
    useEffect(() => {
        handleFetchFilters();
        if (Object.keys(offerData).length > 0) {
            offerData?.items[prodItem[selectedCriteria]?.id]?.orderValue
        }
        if (categories && Object.keys(categories).length > 0) {
            const data = transform(categories, '', 1);
            setresult(data)
            setmainCategories(Object.keys((data)))
        }
    }, [])

    const handleTotalValue = (arr) => {
        const List = arr;
        let totalCount = 0;
        List.map((item) => {
            totalCount += Number(CriteriaObj[prodItem[selectedCriteria].id].cartCount[item.CONCATENATED_SEGMENTS]) * Number(item.LIST_PRICE)
        })
        setOrderValue(totalCount);
        setupdateAmount(!updateAmount)
        return totalCount

    }
    const handleDiscount = () => {
        const localValue = JSON.parse(localStorage.getItem('deal_obj'));
        const { items } = ViewOffer
        const criteria = items.product_criterion[selectedCriteria]
        const max = criteria.OFFER_PARAMETER === "quantity" ? criteria.MAX_QUANTITY : criteria.MAX_VALUE;
        const min = criteria.OFFER_PARAMETER === "quantity" ? criteria.MIN_QUANTITY : criteria.MIN_VALUE;
        const OrderVal = criteria.OFFER_PARAMETER === "quantity" ? GetCartCount(selectedCriteria, 'total') : OrderValue
        const maxDiscount = Number(criteria.MAX_DISCOUNT)
        let discount = 0
        if (OrderVal <= Number(max) && OrderVal >= Number(min)) {
            let TD = criteria.discount_parameter === '0' ? Number(criteria.TRADE_DISCOUNT) / 100 : Number(criteria.TRADE_DISCOUNT)
            let AD = criteria.discount_parameter === '0' ? Number(criteria.ADDITIONAL_DISCOUNT) / 100 : Number(criteria.ADDITIONAL_DISCOUNT)
            discount = criteria.discount_parameter === '0' ? (OrderVal * TD) + (OrderVal * AD) : (OrderVal * TD) / 100 + (OrderVal * AD) / 100
            if (maxDiscount > 0 && discount > maxDiscount) {
                discount = maxDiscount
            }
            return discount
        } else {
            let TD = criteria.TRADE_DISCOUNT / 100
            discount = (OrderVal * TD)
            if (maxDiscount > 0 && discount > maxDiscount) {
                discount = maxDiscount
            }
            return discount
        }
    }
    const handleError = (prod, COUNT) => {
        let status = false;
        if (Number(COUNT[prod.CONCATENATED_SEGMENTS]) < Number(prod.MINIMUM_ORDER_QUANTITY)) {
            status = true
        }
        if (Number(COUNT[prod.CONCATENATED_SEGMENTS]) % Number(prod.PACKING_SIZE || 1) !== 0) {
            status = true

        }
        return status
    }
    const setcartCount = (id, val, item, action) => {
        if (IsSameDeal !== '') {
            setshowNotMaching('active');
            return
        }
        let obj = { ...CriteriaObj }
        const itemProducts = obj[prodItem[selectedCriteria].id].cartItems || [];
        obj[prodItem[selectedCriteria].id].cartItems = itemProducts;
        const orderValue = handleTotalValue(itemProducts)
        obj[prodItem[selectedCriteria].id].orderValue = orderValue
        obj[prodItem[selectedCriteria].id].discount = handleDiscount()
        obj[prodItem[selectedCriteria].id].netTotal = orderValue - handleDiscount();
        obj[prodItem[selectedCriteria].id].CheckError = handleError(item, obj[prodItem[selectedCriteria].id].cartCount)
        const copyCount = { ...cartCountObj }
        if (val === '') val = 0;
        if ((parseFloat(val) && (Math.round(parseFloat(val * 10000)) % Math.round((item?.PACKING_SIZE == null ? 1 : item?.PACKING_SIZE) * 10000) !== 0))) {
            setErrorID(item.INVENTORY_ITEM_ID);
            copyCount[item.CONCATENATED_SEGMENTS] = Number(val)
            setcartCountObj(copyCount)
            return;
        } else {
            setErrorID('');
            item.quantity = parseFloat(val)
            item.item_id = String(item.INVENTORY_ITEM_ID)
            item.deal = offerId
            if (specialRecurring) {
                distributorService.AddSpecialRecurringOfferToCart(item).then((res) => {
                    if (!res.error && res.data.success_status) {
                        SpecialList(obj, prodItem)
                    }
                })
            } else {
                distributorService.AddSpcialOfferToCart(item).then((res) => {
                    if (!res.error && res.data.success_status) {
                        SpecialList(obj, prodItem)
                    }
                })
            }

            if (action) {
                copyCount[item.CONCATENATED_SEGMENTS] = Number(val)
                setcartCountObj(copyCount)
            }
        }



    }
    const handleSearch = (val) => {
        let obj = { ...CriteriaObj }
        obj[prodItem[selectedCriteria].id].payload.search = val;
        obj[prodItem[selectedCriteria].id].payload.page = 1;
        obj[prodItem[selectedCriteria].id].payload.limit = 10;
        setsearchValue(val)
        setCriteriaObj(obj);
        GetProductList(obj)


    }
    const loadFunc = (item) => {
        setinfiniteLoader(true)
        let obj = { ...CriteriaObj }
        obj[prodItem[selectedCriteria].id].payload.page = Number(obj[prodItem[selectedCriteria].id].payload.page) + 1;
        setCriteriaObj(obj);
        GetProductList(obj);
        setTimeout(() => {
            setinfiniteLoader(false)
        }, 2000);
    }
    const [responsivePopup, setresponsivePopup] = useState(false)
    return (
        <div className="products">
            <div className="flex w-full mt-6 lg:flex-nowrap flex-wrap pb-6">
                <div className="lg:min-w-[75%] w-full sm:mr-5 mr-0">
                    <div className="flex justify-between items-center w-[100%] sm:flex-nowrap flex-wrap">
                        <div className="flex justify-between sm:items-center items-start w-full">
                            <p className="text-[#090406] font-semibold text-xs5 w-full">
                                Products ({CriteriaObj[prodItem[selectedCriteria]?.id]?.products?.length} of {CriteriaObj[prodItem[selectedCriteria]?.id]?.total_result})
                            </p>
                        </div>
                        {responsivePopup && (
                            <ResposiveFilterModal
                                handlePayload={handlePayload}
                                payload={payload}
                                setpriceRange={setpriceRange}
                                handleApply={handleApply}
                                Filters={Filters}
                                priceRange={priceRange}
                                Segments={Segments}
                                setSegments={setSegments}
                                // handleSelect={handleSelect}
                                setSize={setSize}
                                Size={Size}
                                result={result}
                                handleCheckBox={handleCheckBox}
                                checkBox={checkBox}
                                handleClear={handleClear}
                                resposivePopup={responsivePopup}
                                setresposivePopup={setresponsivePopup}
                                filterParam={filterParam}
                            />
                        )}
                        <div className="flex sm:mt-0 mt-3 sm:justify-end justify-between items-center w-full">
                            <button
                                onClick={() => setresponsivePopup(true)}
                                type="button" className="bg-[#E9EDF4] font-bold text-xs h-9 text-[#555259] border-2 border-[#E9EDF4] py-1 px-4 rounded-[9px]" data-bs-toggle="modal" data-bs-target="#filtermodal">
                                Filter
                                <span className="inline-block ml-1 hidden filter"><img src="/images/filter-1.svg" alt="icon" /></span>
                            </button>
                            <div className="ml-3 relative cursor-pointer sm:mt-0 mt-1">
                                <input type="text"
                                    onChange={(e) => handleSearch(e.target.value)}
                                    value={CriteriaObj[prodItem[selectedCriteria].id]?.search}
                                    className="w-[230px] h-9 border-2 border-[#E9EDF4] rounded-lg text-sm font-normal text-[#090406] placeholder:font-normal placeholder:text-sm placeholder:text-[#090406] pl-4 pr-14 outline-0"
                                    placeholder="Search" />
                                <img src="/images/search-box.svg" alt="icon" className="absolute top-1.5 right-1" />
                            </div>
                        </div>
                    </div>
                    <div
                        id="scrollableDiv"
                        style={{
                            height: 320,
                            overflow: 'overlay',
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                    >
                        {/*Put the scroll bar always on the bottom*/}
                        {productsloader ? <OffersProductsSkeleton /> : CriteriaObj[prodItem[selectedCriteria].id]?.products?.length > 0 ? (
                            <InfiniteScroll
                                dataLength={Number(CriteriaObj[prodItem[selectedCriteria].id].products.length)} //This is important field to render the next data
                                next={loadFunc}
                                style={{ display: 'flex', flexDirection: 'column' }} //To put endMessage and loader to the top.
                                // inverse={true} //
                                hasMore={CriteriaObj[prodItem[selectedCriteria].id].products.length < Number(CriteriaObj[prodItem[selectedCriteria].id].total_result)}
                                loader={infiniteLoader ? <OffersProductsSkeleton /> : ''}
                                scrollableTarget="scrollableDiv"
                                pullDownToRefreshThreshold={50}
                            >

                                {CriteriaObj[prodItem[selectedCriteria].id]?.products.map((item, i) => (
                                    <OfferProductCard idx={i}
                                        key={i}
                                        cartCountObj={cartCountObj}
                                        prod={item}
                                        prodItem={prodItem}
                                        GetCartItems={GetCartItems}
                                        ErrorID={ErrorID}
                                        selectedCriteria={selectedCriteria}
                                        setErrorID={setErrorID}
                                        CriteriaObj={CriteriaObj}
                                        cartCount={cartCount}
                                        wishProducts={wishlistProduct}
                                        specialCartList={specialCartList}
                                        setInitialloader={setloading}
                                        setcartCount={setcartCount} />
                                ))}
                            </InfiniteScroll>) :
                            <EmptyPage tag="no products" />

                        }
                    </div>
                    {/* {productsloader && <OffersProductsSkeleton />} */}
                </div>
                {<IndividualCriteriaSummary
                    prodItem={prodItem}
                    criteriaObject={criteriaObject}
                    i={selectedCriteria}
                    ViewOffer={ViewOffer}
                    GetCartCount={GetCartCount}
                    OrderValue={OrderValue}
                    handleDiscount={handleDiscount}
                    offerData={offerData}
                    setselectedCriteria={setselectedCriteria}
                    GetOfferData={GetOfferData}
                    updateAmount={updateAmount}
                    setshowProducts={setshowProducts}
                    setsearchValue={setsearchValue}
                    showNotMaching={showNotMaching}
                    setupdateAmount={setupdateAmount}
                    specialRecurring={specialRecurring}
                    criteriaMainObject={criteriaMainObject}
                    subsequentOrder={subsequentOrder}/>}
            </div>
        </div>
    )
}
